// Помощники вставки блоков для функций (features). id новым узлам ставит normalize.ts.
import type { Editor, JSONContent } from '@tiptap/core';
import { NodeSelection, TextSelection } from '@tiptap/pm/state';
import { closeHistory } from '@tiptap/pm/history';

/** Вставить блок(и) на место курсора: пустой абзац заменяется, иначе - после текущего блока верхнего уровня
 *  (или внутри приложения - после текущего блока приложения). Возвращает позицию начала вставки. */
export function insertBlocks(editor: Editor, blocks: JSONContent | JSONContent[], at?: number): number {
  const list = Array.isArray(blocks) ? blocks : [blocks];
  // вставка объекта - отдельный шаг отмены (Ctrl+Z не откатывает вместе с ней набранный перед этим текст)
  editor.view.dispatch(closeHistory(editor.state.tr));
  const r = insertBlocksRaw(editor, list, at);
  editor.view.dispatch(closeHistory(editor.state.tr));
  return r;
}

function insertBlocksRaw(editor: Editor, list: JSONContent[], at?: number): number {
  const { state } = editor;
  let pos: number;
  if (at !== undefined) {
    pos = at;
  } else if (state.selection instanceof NodeSelection && ['doc', 'appendix'].includes(state.selection.$from.parent.type.name)) {
    // выделен объект (формула, рисунок, таблица): вставка - после него, а не вместо
    pos = state.selection.to;
  } else {
    const $from = state.selection.$from;
    // глубина блока-«родителя» верхнего уровня (doc или appendix)
    let d = $from.depth;
    while (d > 0 && !['doc', 'appendix'].includes($from.node(d - 1).type.name)) d--;
    if (d === 0) { pos = state.selection.from; } else {
      const blk = $from.node(d);
      if (blk.type.name === 'paragraph' && blk.content.size === 0) {
        // пустой абзац - заменить
        const from = $from.before(d);
        editor.chain().focus().insertContentAt({ from, to: from + blk.nodeSize }, list).run();
        return from;
      }
      pos = $from.after(d);
    }
  }
  editor.chain().focus().insertContentAt(pos, list).run();
  return pos;
}

/** Поставить курсор внутрь первого текстового узла начиная с pos (например, в подпись нового рисунка). */
export function focusInside(editor: Editor, pos: number) {
  const { doc } = editor.state;
  let target = -1;
  doc.nodesBetween(pos, Math.min(doc.content.size, pos + 2000), (n, p) => {
    if (target >= 0) return false;
    if (n.isTextblock) { target = p + 1 + n.content.size; return false; }
    return true;
  });
  if (target >= 0) editor.view.dispatch(editor.state.tr.setSelection(TextSelection.create(editor.state.doc, target)).scrollIntoView());
  editor.view.focus();
}
